import { render, staticRenderFns } from "./HeadBlock.vue?vue&type=template&id=81ad4264&scoped=true"
import script from "./HeadBlock.vue?vue&type=script&lang=js"
export * from "./HeadBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ad4264",
  null
  
)

export default component.exports